export default __webpack_public_path__ + "static/media/logo-sm.baa5c72f.svg";